export default __webpack_public_path__ + "static/media/menu.fe947130.svg";